// extracted by mini-css-extract-plugin
module.exports = {"title":"VehicleInfoHeader_title__1WdWl","spacingBorder":"VehicleInfoHeader_spacingBorder__sf-Qx"};